import { render, staticRenderFns } from "./para.vue?vue&type=template&id=13f9c5be&"
import script from "./para.vue?vue&type=script&lang=js&"
export * from "./para.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports